angular.module('tgaAdmin').controller('PlayerListController', [
  '$scope',
  '$state',
  'playerListService',
  'userService',
  'flashService',
  'Papa',
  'modalService',
  '$translate',
  function ($scope, $state, playerListService, userService, flashService, Papa, modalService, $translate) {
    $scope.showBack = true;

    $scope.data = {
      alerts: [],
      playerListId: $state.params.id || null,
      csv: {
        file: null,
      },
    };

    $scope.viewmodel = {
      name: null,
      users: [],
      email: null,
    };

    $scope.initialize = function () {
      if ($scope.data.playerListId) {
        playerListService.getPlayerList($scope.data.playerListId).then((playerList) => {
          for (let i = 0; i < playerList.users.length; i++) {
            $scope.viewmodel.users.push(playerList.users[i].username);
          }
          $scope.viewmodel.name = playerList.name;
          $scope.title = `<span class="text-muted">Edit Player List /</span> ${$scope.viewmodel.name}`;
        });
      }
    };

    $scope.actions = {
      addCSV() {
        Papa.parse($scope.data.csv.file.file, {
          header: false,
          dynamicTyping: true,
          complete(results) {
            for (let i = 0; i < results.data.length; i++) {
              // if you upload multiple csv's make sure we have no duplicate emails
              if (results.data[i][0] && $scope.viewmodel.users.indexOf(results.data[i][0]) === -1) {
                $scope.viewmodel.users.push(results.data[i][0]);
              }
            }
            $scope.$apply();
            // reset the file input
            $('.csv-button').val('');
          },
        });
      },
      removePlayer(player) {
        const index = $scope.viewmodel.users.indexOf(player);
        $scope.viewmodel.users.splice(index, 1);
      },
      deleteList() {
        modalService
          .showModal(
            {
              title: 'Delete Player List?',
              message: 'Are you sure you want to delete this player list?',
              closeButton: 'No',
              actionButton: 'Yes',
            },
            {
              backdrop: true,
              keyboard: true,
              animation: false,
            },
          )
          .then(
            () => {
              $scope.deleting = true;

              const formData = {
                name: $scope.viewmodel.name,
                users: $scope.viewmodel.users,
                playerListId: $scope.data.playerListId,
                domain: null,
              };

              playerListService.deletePlayerList(formData).then(
                () => {
                  flashService.set('<span class="fa fa-check"></span> Player list deleted.', 'success');

                  if ($state.current.data.is_hub) {
                    $state.go('v1.hub.playerLists');
                  } else {
                    $state.go('v1.playerLists');
                  }
                },
                (error) => {
                  $scope.actions.createAlert(
                    `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                    'danger',
                  );
                  $scope.deleting = false;
                },
              );
            },
            () => {},
          );
      },
      addEmail() {
        // make sure there is no duplicate
        if (
          $scope.viewmodel.users
            .toString()
            .toLowerCase()
            .indexOf($scope.viewmodel.email.toLowerCase()) === -1
        ) {
          $scope.viewmodel.users.push($scope.viewmodel.email);
        }
        $scope.viewmodel.email = '';
      },
      submit(form) {
        form.submitted = true;

        $scope.data.alerts = [];

        if (form.$invalid) {
          $scope.actions.createAlert(
            `<span class="fa fa-exclamation-triangle"></span> ${$translate
              .instant('common.check_form_for_errors')
              .toString()}`,
            'danger',
          );
          return;
        }

        $scope.processing = true;

        if ($scope.data.playerListId) {
          const formData = {
            name: $scope.viewmodel.name,
            users: $scope.viewmodel.users,
            playerListId: $scope.data.playerListId,
            domain: null,
          };

          playerListService.updatePlayerList(formData).then(
            () => {
              flashService.set('<span class="fa fa-check"></span> Player list updated.', 'success');
              if ($state.current.data.is_hub) {
                $state.go('v1.hub.playerLists');
              } else {
                $state.go('v1.playerLists');
              }
            },
            (error) => {
              $scope.actions.createAlert(
                `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                'danger',
              );
              $scope.processing = false;
            },
          );
        } else {
          const formData = {
            name: $scope.viewmodel.name,
            users: $scope.viewmodel.users,
            domain: null,
          };

          playerListService.addPlayerList(formData).then(
            () => {
              flashService.set('<span class="fa fa-check"></span> Player list created.', 'success');
              if ($state.current.data.is_hub) {
                $state.go('v1.hub.playerLists');
              } else {
                $state.go('v1.playerLists');
              }
            },
            (error) => {
              $scope.actions.createAlert(
                `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                'danger',
              );
              $scope.processing = false;
            },
          );
        }
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
    };

    $scope.initialize();
  },
]);
